// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs-kGNoc","separator":"separator-LSOoW","active":"active-yslYH"};